var map = {
	"./dada_hiboos_logo.png": 269,
	"./dy_business.png": 30936,
	"./dy_hiboos.png": 70040,
	"./front_scene.png": 82542,
	"./hiboos_icon_d.png": 72113,
	"./hiboos_icon_h.png": 51309,
	"./homepage_long.png": 29327,
	"./jd_icon.png": 47184,
	"./jd_icon_d.png": 94981,
	"./jd_icon_h.png": 8121,
	"./service_1_icon.png": 81487,
	"./service_2_icon.png": 16586,
	"./service_3_icon.png": 6665,
	"./service_4_icon.png": 37844,
	"./service_5_icon.png": 69595,
	"./service_tech.png": 18528,
	"./service_tech_1.png": 46392,
	"./service_tech_2.png": 20883,
	"./service_tech_3.png": 70122,
	"./supermarket_scene.png": 42650,
	"./telephone_icon.png": 34076,
	"./wx_chat.png": 9428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83411;